module.exports = __webpack_public_path__ + "img/vitaz_testu.b0e14d43.png";